export default "__VITE_ASSET__CnP2RXiq__"